import { render, staticRenderFns } from "./f2g-button.vue?vue&type=template&id=2ae01358&scoped=true"
import script from "./f2g-button.vue?vue&type=script&lang=js"
export * from "./f2g-button.vue?vue&type=script&lang=js"
import style0 from "./f2g-button.vue?vue&type=style&index=0&id=2ae01358&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ae01358",
  null
  
)

export default component.exports